import * as signalR from "@microsoft/signalr";

/**
 * SignalR Event Handlers
 * Manages registration and handling of SignalR events
 */
class SignalRHandlers {
  constructor(connection) {
    this.connection = connection;
    this.clubStatusCallback = null;
    this.permissionStatusCallback = null;
    this.forceLogoutCallback = null;
  }

  /**
   * Register ClubStatus event handler callback
   * Backend sends: SendAsync("ClubStatus", user.defaultClubId, "Club changed successfully.")
   */
  registerClubStatusHandler(callback) {
    this.clubStatusCallback = callback;
  }

  /**
   * Register PermissionStatus event handler callback
   * Backend sends: SendAsync("PermissionStatus", finalResult, "Permissions have been updated successfully.")
   */
  registerPermissionStatusHandler(callback) {
    this.permissionStatusCallback = callback;
    }

    /**
  * Register ForceLogout event handler callback
  * Backend sends: SendAsync("ForceLogout", "Your account has been deactivated.");
  */
    registerForceLogoutHandler(callback) {
        this.forceLogoutCallback = callback;
    }

  /**
   * Register all event handlers on the connection
   * This should be called before connection.start()
   */
  registerAllHandlers() {
    if (!this.connection) {
      return;
    }

    // Register ClubStatus handler
    this.connection.on("ClubStatus", (clubId, message) => {
      if (this.clubStatusCallback) {
        this.clubStatusCallback(clubId, message);
      }
    });

    // Register PermissionStatus handler
    this.connection.on("PermissionStatus", (finalResult, message) => {
      if (this.permissionStatusCallback) {
        this.permissionStatusCallback(finalResult, message);
      }
    });

    // Register ForceLogout handler
    this.connection.on("ForceLogout", (message) => {
      if (this.forceLogoutCallback) {
        this.forceLogoutCallback(message);
      }
    });
  }

  /**
   * Get ClubStatus callback
   */
  getClubStatusCallback() {
    return this.clubStatusCallback;
  }

  /**
   * Get PermissionStatus callback
   */
  getPermissionStatusCallback() {
    return this.permissionStatusCallback;
    }
    /**
    * Get ForceLogout callback
    */

  getForceLogoutCallback() {
    return this.forceLogoutCallback; 
  }
}

export default SignalRHandlers;

